import './App.css';

function App() {
	return (
		<div className="App">
			<div className="logo" style={{ fontFamily: 'Osnova', fontWeight: 900 }}>
				UNFILTERED.
			</div>
			<div className="info">
				<div>11 October 2025</div>
				<div>@Escape Venue</div>
			</div>
            <div>
                <h4>Available packs</h4>
                <div className="packs">
                    <a
                        className="pack"
                        href="https://one-two.ro/en/unfiltered/96-unfiltered-2025-early-bird-20.html"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src={process.env.PUBLIC_URL + '/earlyblind.jpg'}
                            alt="Early blind bird"
                            className="pack-img"
                        />
                        <div className="pack-details">
                            <div className="pack-title">Early blind bird</div>
                            <div className="pack-tokens">20 TOKENS + GLASS</div>
                        </div>
                    </a>
                </div>
            </div>
			<footer className="footer">
				<img
					src={process.env.PUBLIC_URL + '/onetwo.png'}
					alt="OneTwo logo"
					className="footer-logo"
                    style={{ filter: 'invert(1)' }}
				/>
			</footer>
		</div>
	);
}


export default App;
